import React, { FC } from 'react';
import { useMobileNav } from '../../contexts/MobileNavContext';
import { ReactComponent as SidebarPanelIcon } from '../../icons/sidebar-panel.svg';
import './mobile-nav-toggle.scss';

const MobileNavToggle: FC = () => {
  const { isMobile, openMobileNav } = useMobileNav();

  if (!isMobile) return null;

  return (
    <div className='mobile-nav-toggle-header'>
      <button
        className='mobile-nav-toggle-btn'
        onClick={openMobileNav}
        aria-label='Open navigation'
      >
        <SidebarPanelIcon />
      </button>
    </div>
  );
};

export default MobileNavToggle;
